(() => {
    const selector = '.footer-country-selector__form';

    // FB-92: Shopify sets a visitor's country from their IP on the first visit only, then keeps it
    // for a year. A Philippine shopper who once landed in the Singapore market keeps seeing SGD
    // until they change the footer selector. These countries have their own prices, so visitors
    // located there are moved to them automatically unless they picked a country themselves.
    const autoCountries = ['PH'];
    const choiceKey = 'dlCountryChoice';
    const checkedKey = 'dlCountryLocationChecked';

    const readStorage = (area, key) => {
        try {
            return window[area].getItem(key);
        } catch (error) {
            return null;
        }
    };

    const writeStorage = (area, key, value) => {
        try {
            window[area].setItem(key, value);
            return true;
        } catch (error) {
            return false;
        }
    };

    const matchVisitorCountry = () => {
        const shopify = window.Shopify || {};
        const currentCountry = shopify.country;

        if (!currentCountry || shopify.designMode || autoCountries.includes(currentCountry)) {
            return;
        }

        if (readStorage('localStorage', choiceKey)) {
            return;
        }

        // One check per browser session. Without session storage there is no check at all, so a
        // switch that doesn't take effect can never turn into a reload loop.
        if (readStorage('sessionStorage', checkedKey) || !writeStorage('sessionStorage', checkedKey, 'true')) {
            return;
        }

        fetch(`/browsing_context_suggestions.json?country[enabled]=true&country[exclude]=${encodeURIComponent(currentCountry)}`)
            .then((response) => (response.ok ? response.json() : null))
            .then((suggestions) => {
                const detected = suggestions && suggestions.detected_values && suggestions.detected_values.country;
                const detectedCountry = detected && detected.handle;

                if (!autoCountries.includes(detectedCountry) || detectedCountry === currentCountry) {
                    return;
                }

                const url = new URL(window.location.href);

                url.searchParams.set('country', detectedCountry);
                window.location.replace(url.toString());
            })
            .catch(() => {});
    };

    const initialize = (form) => {
        if (form.dataset.dlCountrySelectorInitialized === 'true') {
            return;
        }

        const countrySelect = form.querySelector('[data-dl-country-select]');

        if (!countrySelect) {
            return;
        }

        countrySelect.addEventListener('change', () => {
            const url = new URL(window.location.href);

            writeStorage('localStorage', choiceKey, countrySelect.value);
            url.searchParams.set('country', countrySelect.value);
            window.location.assign(url.toString());
        });

        form.dataset.dlCountrySelectorInitialized = 'true';
    };

    const initializeAll = (container = document) => {
        if (container.matches && container.matches(selector)) {
            initialize(container);
        }

        container.querySelectorAll(selector).forEach(initialize);
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
    } else {
        initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));

    matchVisitorCountry();
})();
